import Swal from "sweetalert2";
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import styled from 'styled-components';
import EditIcon from 'mdi-react/EditIcon';
import React, { useEffect, useState } from 'react';
import AdminInterface from '@/utils/AdminInterface';
import { colorFieldsBorder } from '@/utils/palette';
import withReactContent from "sweetalert2-react-content";
import DeleteForeverIcon from 'mdi-react/DeleteForeverIcon';
import { paddingLeft, paddingRight } from '@/utils/directions';
import { colorAdditional, colorRedHover } from '@/utils/palette';
import ReactTableBase from '@/shared/components/table/ReactTableBase';
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';

const CartTableButton = styled.button`
  background: transparent;
  border: none;
  line-height: 14px;
  ${paddingLeft}: 20px;
  ${paddingRight}: 0;
  padding-top: 0;
  padding-bottom: 0;
  position: relative;
  color: ${colorAdditional};
  cursor: pointer;
  transition: all 0.3s;

  svg {
    height: 20px;
    width: 20px;
    fill: ${colorAdditional};
    transition: all 0.3s;
  }

  &:hover {
    color: ${colorRedHover};

    svg {
      fill: ${colorRedHover};
    }
  }
`;

const ProductImageWrap = styled.div`
  width: 40px;
  height: 35px;
  text-align: center;
  padding: 2px;
  border: 1px solid ${colorFieldsBorder};

  img {
    max-height: 100%;
    width: auto;
  }
`;

const PhotoFormatter = value => (
    <ProductImageWrap>
        <img src={value} alt="" />
    </ProductImageWrap>
);

const OrganizationsList = (props) => {
    const [organizationsList, setOrganizationsList] = useState({ tableHeaderData: [], tableRowsData: [] });
    const tableConfig = {
        isSortable: true,
        withPagination: true,
        withSearchEngine: true,
        placeholder: 'Search...',
    };

    const deleteOrganization = (organization_id) => {
        AdminInterface.instance.deleteOrganization(organization_id).then(() => {
            Swal.fire('Deleted!', '', 'success')
            props.setListRequiresReload(true);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response.data?.detail,
            });
        });
    }

    const handleDelete = (organization_id) => {
        Swal.fire({
            title: 'Do you want to permanently delete the organization?',
            showDenyButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                deleteOrganization(organization_id);
            }
        })
    }

    const handleEdit = (organization_id) => {
        props.setEditOrganizationIdHandler(organization_id)
    }

    const GetOrganizations = () => {
        AdminInterface.instance.getOrganizations().then((response) => {
            const columns = [
                {
                    accessor: 'logo',
                    Header: 'Logo',
                    disableGlobalFilter: true,
                    disableSortBy: true,
                },
                {
                    accessor: 'name',
                    Header: 'Name'
                },
                {
                    accessor: 'display_name',
                    Header: 'Display Name'
                },
                {
                    accessor: 'postalCode',
                    Header: 'Postal Code',
                    disableSortBy: true
                },
                {
                    accessor: 'domain',
                    Header: 'Domain',
                    disableSortBy: true
                },
                {
                  accessor: 'edit',
                  Header: 'Edit',
                  disableGlobalFilter: true,
                  disableSortBy: true
                },
                {
                  accessor: 'delete',
                  Header: 'Delete',
                  disableGlobalFilter: true,
                  disableSortBy: true
                }
            ];
            const data = [];
            response.data.forEach(organization => {
                data.push({
                    logo: PhotoFormatter(organization.logo_url),
                    id: organization.user_id,
                    name: organization.name,
                    display_name: organization.display_name,
                    postalCode: organization.postalCode,
                    domain: organization.domain,
                    edit: <CartTableButton type="button" onClick={() => handleEdit(organization.id)}><EditIcon /></CartTableButton>,
                    delete: <CartTableButton type="button" onClick={() => handleDelete(organization.id)}><DeleteForeverIcon /></CartTableButton>,
                });
            });

            const organizationListTableData = { tableHeaderData: columns, tableRowsData: data };
            setOrganizationsList(organizationListTableData);
            props.setListRequiresReload(false);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response.data?.detail,
            });
        })
    };

    useEffect(() => {
        GetOrganizations();
    }, [props.listRequiresReload]);

    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <CardTitleWrap>
                        <CardTitle>Organizations list</CardTitle>
                    </CardTitleWrap>
                    <ReactTableBase
                        columns={organizationsList.tableHeaderData}
                        data={organizationsList.tableRowsData}
                        tableConfig={tableConfig}
                    />
                </CardBody>
            </Card>
        </Col>
    );
};

OrganizationsList.propTypes = {
    organizationListTableData: PropTypes.shape({
        tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.string,
            name: PropTypes.string,
        })),
        tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    }).isRequired,
};

export default OrganizationsList;
